import { faLightbulb, faSlidersH } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Divider, Grid, makeStyles, Paper, Typography, useMediaQuery } from '@material-ui/core';
import SpeedIcon from '@material-ui/icons/Speed';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import React from 'react';
import './about.css';
// ---- IMPORT COMPONENTS ------------------------------------- //
import ProfileDetails from './ProfileDetail';

const listOfIcons = [
  {icon: <SpeedIcon fontSize='inherit' style={{color: 'green'}} />}, 
  {icon: <FontAwesomeIcon icon={faLightbulb}/>}, 
  {icon: <FontAwesomeIcon icon={faSlidersH} />}, 
  {icon: <TrendingUpIcon fontSize='inherit' />}
];
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  heading: {
    marginTop: '8vh',
    letterSpacing: '1px',
    color: '#383838',
  },
  divider: {
    height: '6px',
    width: '20%',
    margin: '1vh auto',
    background: 'linear-gradient(to right, #ffff00 0%, #33cc33 100%)'
  },
  center: {display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center'},
  paperGrid: {display: 'flex', flexDirection: 'column'},
  paper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: 120,
    width: 120,
    margin: '3vh auto',
    textAlign: 'center',
    position: 'relative',
  },
  paperIcon: {fontSize: '5rem'},
  qualityHeading: {wordBreak: 'break-word'},
  qualityPara: { fontSize: '1.1rem', wordBreak: 'break-word'}
}));
function About(props) {
  const classes = useStyles();
  const matches = useMediaQuery('(max-width: 700px)')
  const {qualities} = props;
  const qualifications = qualities.map((quality, ind) => (
    <Grid key={ind} item className={classes.paperGrid} style={matches ? {minWidth: '20%'} : {maxWidth: '18%'}} >
      <Paper className={classes.paper} key={ind} elevation={3}>
        <div className={classes.paperIcon} >
          {listOfIcons[ind].icon}
        </div>
      </Paper>
      <Typography className={`${classes.center} ${classes.qualityHeading}`} variant='h5'>{quality.adjective}</Typography>
      <Typography className={`${classes.center} ${classes.qualityPara}`} variant='body2'>{quality.body}</Typography>
    </Grid>
  ))
  return (
    <div className={classes.root}>
      <Container maxWidth="xl">
        <Typography className={classes.heading} variant='h3' align='center'>
          ABOUT
        </Typography>
        <Divider className={classes.divider} variant='fullWidth' />
        <Grid container item xs={12} spacing={2} justify="center" style={{margin: 0}} >
          {qualifications}
        </Grid>
        <ProfileDetails {...props}/>
      </Container>
    </div>
  );
}

export default About;